// From https://stackoverflow.com/a/19189846/562947
module.exports.getCookie = function getCookie(key) {
  var cookies = document.cookie.split(';');
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = cookies[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var cookie = _step.value;
      var oPair = cookie.split('=');
      var sKey = decodeURIComponent(oPair[0].trim().toLowerCase());
      var sValue = oPair.length > 1 ? oPair[1] : '';

      if (sKey == key.toLowerCase()) {
        return decodeURIComponent(sValue);
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return '';
};

module.exports.setCookie = function setCookie(sName, sValue) {
  var oDate = new Date();
  oDate.setYear(oDate.getFullYear() + 1);
  var sCookie = encodeURIComponent(sName) + '=' + encodeURIComponent(sValue) + ';expires=' + oDate.toGMTString() + ';path=/';
  document.cookie = sCookie;
};

module.exports.clearCookie = function clearCookie(sName) {
  this.setCookie(sName, '');
};